import React from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import { ErrorMessage } from "formik";
import { CheckboxInputComponentProps } from "./checkbox-input-component.props";
import "./checkbox-input-component.scss";

const CheckboxInputComponent: React.FC<CheckboxInputComponentProps> = ({
  listCheckbox = [],
  label,
  optional = false,
  value,
  onChange,
  fieldName = "",
  isMultiSelect = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dataUpdate = value?.map((data: any) =>
      event.target.name === data?.name
        ? { ...data, checked: !data?.checked }
        : isMultiSelect
          ? data
          : { ...data, checked: false }
    );
    onChange(dataUpdate);
  };

  return (
    <Box>
      <div className="form-checkbox-input-component">
        {label && (
          <InputLabel required={optional} htmlFor={fieldName}>
            {label}
          </InputLabel>
        )}
        <FormGroup>
          {listCheckbox?.map((data: any) => (
            <FormControlLabel
              key={data?.id}
              control={
                <Checkbox
                  checked={data?.checked}
                  onChange={handleChange}
                  name={data?.name}
                />
              }
              label={data?.label}
            />
          ))}
        </FormGroup>
        <ErrorMessage
          name={fieldName}
          component="div"
          className="error-message"
        />
      </div>
    </Box>
  );
};

export default CheckboxInputComponent;
